import {Component, Input} from '@angular/core';
import {Message, MessageType} from '../../../contracts/message.interface';
import {MessageImageComponent} from '../message-image/message-image.component';
import {MessageVideoComponent} from '../message-video/message-video.component';
import {MessageAudioComponent} from '../message-audio/message-audio.component';
import {MessageDocumentComponent} from '../message-document/message-document.component';
import {MessageTextComponent} from '../message-text/message-text.component';
import {DatePipe, NgSwitch, NgSwitchCase, NgSwitchDefault} from '@angular/common';
import {MessageQuoteComponent} from '../message-quote/message-quote.component';
import {MessageAiInsightsComponent} from '../message-ai-insights/message-ai-insights.component';

@Component({
  standalone: true,
  selector: 'app-message-renderer',
  imports: [
    MessageImageComponent,
    MessageVideoComponent,
    MessageAudioComponent,
    MessageDocumentComponent,
    MessageTextComponent,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    MessageQuoteComponent,
    DatePipe,
    MessageAiInsightsComponent,
  ],
  templateUrl: './message-renderer.component.html',
  styleUrl: './message-renderer.component.scss'
})
export class MessageRendererComponent {
  @Input() message!: Message;
  @Input() showInfo = true;
  @Input() showAiInsights = true;

  readonly TEXT_PREFIX = 'text/';
  readonly IMAGE_PREFIX = 'image/';
  readonly VIDEO_PREFIX = 'video/';
  readonly AUDIO_PREFIX = 'audio/';
  readonly DOC_PREFIX = 'application/';

  get mime(): string {
    return this.message?.mimeType || 'text/plain';
  }

  /** Restituisce il tipo logico in base al prefisso MIME */
  get type(): 'text' | 'image' | 'video' | 'audio' | 'document' | 'quote' | 'unknown' {
    const mime = this.mime.toLowerCase();

    if (this.message.isQuote) return 'quote';
    if (mime.startsWith(this.TEXT_PREFIX)) return 'text';
    if (mime.startsWith(this.IMAGE_PREFIX)) return 'image';
    if (mime.startsWith(this.VIDEO_PREFIX)) return 'video';
    if (mime.startsWith(this.AUDIO_PREFIX)) return 'audio';
    if (mime.startsWith(this.DOC_PREFIX)) return 'document';
    return 'unknown';
  }

  isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }

  get messageDateFormat(): string {
    const raw = this.message?.creationDate;
    if (!raw) {
      return 'HH:mm';
    }

    const creationDate = new Date(raw as string | number | Date);
    if (isNaN(creationDate.getTime())) {
      return 'HH:mm';
    }

    const today = new Date();
    return this.isSameDay(creationDate, today) ? 'HH:mm' : 'dd/MM/YYYY HH:mm';
  }

  protected readonly MessageType = MessageType;
}
